<et-step-layout [data]="data">
  <div class="flex flex-column">
    <span class="title3Font mb-2"
          i18n>Project</span>

    @if (!isReadonly) {
      <span class="body2Font mb-4"
            i18n>Choose a project you want to publish in</span>
      @for (projectData of projectsData$ | async; track projectData) {
        <div class="et-projects mb-5">
          <div class="et-project-info">
            <et-paper-project [projectData]="projectData"
                              [selected]="(selectedProject$ | async)?.project?.titleId === projectData.project.titleId">
            </et-paper-project>
          </div>
        </div>
      }
    }

    @if (isReadonly) {
      <div class="et-project-info">
        <et-paper-project [projectData]="selectedProject$ | async"
                          [selected]="true"
                          [isReadonly]="true">
        </et-paper-project>
      </div>
    }
  </div>
</et-step-layout>